import { black, green, neutral6, primary, primaryDark2 } from './colors';
import { hexToRGBA } from './utils/colorUtils';

// Modal Back Drop
export const blackDark = hexToRGBA(`${black}`, 0.56);

// Base box shadow colors
export const neutral6ExtraLight = hexToRGBA(`${neutral6}`, 0.08);
export const blackExtraLight = hexToRGBA(`${black}`, 0.08);
export const blackLight = hexToRGBA(`${black}`, 0.16);
export const blueDark = hexToRGBA(`${primary}`, 0.32);
export const blueDarkHover = hexToRGBA(`${primaryDark2}`, 0.32);
export const greenExtraLight = hexToRGBA(`${green}`, 0.08);

// Badge box shadows
export const boxShadowBadge = `0 4px 4px -2px ${hexToRGBA(black, 0.25)}`;

// Switch box shadows
export const boxShadowSwitch = `0 4px 16px 0 ${hexToRGBA(black, 0.04)}`;

// New shadows
export const shadowLevel1 = '0 4px 16px 0 rgba(0, 0, 0, 0.04)';
export const shadowLevel2 = `0 4px 8px 0 ${blueDark}, ${shadowLevel1}`;
export const shadowLevel2Hover = `0 4px 8px 0 ${blueDarkHover}, ${shadowLevel1}`;
export const shadowLevel3 = '0 8px 20px 0 rgba(0, 0, 0, 0.08)';
export const shadowLevel3Right = '13px 0px 13px 0px rgba(0, 0, 0, 0.06)';
export const shadowLevel3Left = '-13px 0px 13px 0px rgba(0, 0, 0, 0.08)';
